import React from "react";
import {
  Filter,
  TextInput,
  Button,
  Link,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  Create,
  List,
  DateInput,
  NumberInput,
  Datagrid,
  TextField, FunctionField, ReferenceField,
  Pagination,
  DisabledInput,
  DateField,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import ItemSwitch from "../components/itemSwitch";
import moment from "moment";

import styled from "styled-components";
const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const SeatPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const HistoryButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/item_history/seats/${props.record.id}`
    }}
    label="Device History"
  >
    <ChatBubbleIcon />
  </Button>
);

const SeatFielter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
  </Filter>
);

const SwitchButton = props => {
  const rentals = props.record.number_rentals || 0;
  if (rentals > 0 && props.record.status === 1) {
    return (
      <ItemSwitch
        item={props.record}
        type={props.resource}
        history={props.history}
        location={props.location}
      />
    );
  }
  return <React.Fragment />;
};

export const SeatList = props => (
  <List
    {...props}
    resource="seats"
    pagination={<SeatPagination />}
    filters={<SeatFielter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Seat ID" source="id" sortable={false} />
      <ReferenceField
        label="Last Location"
        source="location_id"
        reference="locations" sortable={false}
        linkType={false}
      >
        <FunctionField
          label="Last Location"
          addLabel={false}
          render={(locations) => {
            return (
              <StyledDiv color={locations.color}>
                {locations.location_name}
              </StyledDiv>
            );
          }}
        />
      </ReferenceField>
      <FunctionField label="Status" source="status" render={record => (record.status === 1) ? 'Enabled' : 'Disabled'} />
      <TextField
        label="Seat Model"
        source="model"
        sortable={false}
      />
      <DateField
        label="Purchase Date"
        source="purchase_date"
        sortable={false}
      />
      <EditButton />
      <HistoryButton />
      <SwitchButton {...props} />
    </Datagrid>
  </List>
);

const SeatTitle = object => (
  <span>
    {" Edit Seat Device"} &quot;{object.record.model}&quot;
  </span>
);

const SeatCreateTitle = record => <span>Create Seat Device</span>;

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const SeatCreate = props => (
  <Create title={<SeatCreateTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <SelectInput
        label="Size"
        source="size"
        choices={[{ id: "Low", name: "Low" }]}
      />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
      <ReferenceInput
        label="Vehicle Model"
        source="vehicle_model_id"
        reference="vehicle_models"
        filter={{ type: "2" }}
        sort={{ field: "model_name", order: "ASC" }}
        perPage={50}
      >
        <SelectInput source="id" optionText="model_name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const SeatEdit = props => (
  <Edit title={<SeatTitle />} {...props}>
    <SimpleForm>
      <DisabledInput label="Id" source="id" />
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <SelectInput
        label="Size"
        source="size"
        choices={[{ id: "Low", name: "Low" }]}
      />
      <ReferenceInput
        label="Vehicle Model"
        source="vehicle_model_id"
        reference="vehicle_models"
        filter={{ type: "2" }}
        sort={{ field: "model_name", order: "ASC" }}
        perPage={50}
      >
        <SelectInput source="id" optionText="model_name" />
      </ReferenceInput>
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/seats.js